import Header from "../header"
import Footer from "../footer"
import { Box } from "@mui/material"
import useStyles from "./style"

const Layout = ({ children }) => {
  const classes = useStyles()

  return (
    <>
      <Header />
      <Box className={classes.container}>{children}</Box>
      <Footer />
    </>
  )
}

export default Layout
